import { useEffect, useState } from "react";
import axios from "../../../axios";
import ProductForm from "../../components/Product/ProductForm";
import { EditorState } from "draft-js";
import { useNavigate } from "react-router-dom";
import ErrorModal from "../../components/ErrorModal";
import handleApiError from "../../../utils/handleApiError";
import SuccessModal from "../../components/SuccessModal";

export default function ProductCreatePage() {
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);

    const [relations, setRelations] = useState({
        categories: [],
        subcategories: [],
        sizes: [],
        fabrics: [],
        designs: [],
        pages: [],
    });

    const fetchRelations = async () => {
        try {
            const [catRes, sizeRes, fabRes, desRes] = await Promise.all([
                axios.get("/admin/categories"),
                axios.get("/admin/sizes"),
                axios.get("/admin/cover-fabrics"),
                axios.get("/admin/cover-designs"),
            ]);

            const allSub = catRes.data.flatMap(cat => cat.sub_categories || []);
            setRelations({
                categories: catRes.data,
                subcategories: allSub,
                sizes: sizeRes.data,
                fabrics: fabRes.data,
                designs: desRes.data,
                // pages: pageRes.data,
            });
        } catch (err) {
            alert("Gagal memuat data relasi");
        }
    };

    useEffect(() => {
        fetchRelations();
    }, []);

    const handleSubmit = async (formData) => {
        try {
            await axios.post("/admin/products", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            setSuccess("Data berhasil ditambahkan!");
        } catch (err) {
            setError(handleApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="card mt-24">
            <ErrorModal error={error} onClose={() => setError("")} />
            <SuccessModal
                message={success}
                onClose={() => {
                    setSuccess("");
                    navigate("/admin/products");
                }}
            />
            <div className="card-header border-bottom">
                <h4 className="mb-4">Tambah Produk</h4>
            </div>

            <div className="card-body">
                <ProductForm
                    onSubmit={handleSubmit}
                    initialEditorState={EditorState.createEmpty()}
                    relationsOptions={relations}
                />
            </div>
        </div>
    );
}
